import { VolumeMuteRounded, VolumeOffRounded, VolumeUpRounded } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useMuted } from '../audio/mutedContext';

const MuteButton = ({ isPlayingAudio, color }: { isPlayingAudio: boolean, color?: string }) => {
    const [muted, setMuted] = useMuted();
    const tooltip = muted 
        ? (isPlayingAudio   ? "Du hast den Ton ausgeschaltet. Klicke hier, um die Ansage wieder zu hören."
                            : "Du hast den Ton ausgeschaltet. Klicke hier, um zu hören, wenn es weiter geht.")
        : (isPlayingAudio   ? "Klick hier, um die Ansage stumm zu schalten."
                            : "Im Moment läuft kein Ton. Klicke hier, um die Ansage stumm zu schalten. Dann bekommst Du allerdings nicht mit, wenn es weiter geht.");
    return (
        <Tooltip title={tooltip}>

            <IconButton size='small' onClick={() => setMuted(!muted)} color={muted ? 'default' : (color as any || 'primary')} sx={{ pb: 0, pt: 0 }}>
                {
                    muted
                        ? <VolumeOffRounded />
                        : (isPlayingAudio
                            ?
                            <VolumeUpRounded />
                            : <VolumeMuteRounded />
                        )
                }
            </IconButton>
        </Tooltip>
    );
};

export default MuteButton;